import izabela from "../../images/izabela.jpg";
import monika from "../../images/monikaPioro.jpeg";
import styles from "./AboutUs.module.scss";

const AboutUs = () => {
  return (
    <section className={styles.section} id="about_us">
      <div className={styles.wrapper}>
        <h2 className={styles.title}>O nas</h2>

        <div className={styles.aboutUsWrapper}>
          <div className={styles.aboutUs}>
            <div className={styles.photo}>
              <img src={monika} alt="Monika" />
            </div>
            <div className={styles.about_inf}>
              <h3>Cześć, jestem Monika</h3>
              <p>
                Swoją przygodę z kosmetologią rozpoczęłam w 2009 roku na Wyższej
                Szkole Zdrowia i Urody w Gdyni. Od 2012 roku jestem
                licencjonowanym kosmetologiem.
              </p>
              <p>
                Do każdego Klienta podchodzę indywidualnie i oferuję wysoki
                komfort usług. Kosmetologia to moja pasja, dlatego stale
                poszerzam swoją wiedzę.
              </p>
            </div>
          </div>

          <div className={`${styles.aboutUs} ${styles.reverse}`}>
            <div className={styles.photo}>
              <img src={izabela} alt="Izabela" />
            </div>
            <div className={styles.about_inf}>
              <h3>Cześć, jestem Izabela</h3>
              <p>
                Jestem dyplomowaną kosmetyczką. W zawodzie pracuję od 2005 roku.
                Praca z ludźmi to dla mnie ogromna przyjemność.
              </p>
              <p>
                Specjalizuję się w zabiegach z zakresu podologii, stylizacji
                paznokci, pielęgnacji twarzy oraz przedłużania rzęs.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
